import { useNavigate } from "react-router-dom";
import { t, font, Button } from "@realtyflows/ui";

/**
 * TrialGate (now FeatureGate) — shown when a restricted action is blocked.
 * Props:
 *   code: "FREE_SIGNINGS_EXHAUSTED" | "PLAN_SIGNINGS_EXHAUSTED"
 *   message: optional custom message from the API
 *   onDismiss: () => void
 */
export default function TrialGate({ code, message: apiMessage, onDismiss }) {
  const navigate = useNavigate();

  const isPlanLimit = code === "PLAN_SIGNINGS_EXHAUSTED";

  const title = isPlanLimit
    ? "Monthly Signing Limit Reached"
    : "Free Signing Used";

  const message = apiMessage || (isPlanLimit
    ? "You've reached your monthly signing limit for your current plan. Upgrade to get more signings."
    : "This feature requires a paid plan. Subscribe to unlock signings, AI, and automation.");

  const icon = isPlanLimit ? "\uD83D\uDCCA" : "\u270D\uFE0F";
  const iconBg = `${t.amber}15`;

  return (
    <div style={{
      position: "fixed", inset: 0, zIndex: 9999,
      background: "rgba(0,0,0,0.5)", backdropFilter: "blur(4px)",
      display: "flex", alignItems: "center", justifyContent: "center",
    }}
      onClick={onDismiss}
    >
      <div
        onClick={e => e.stopPropagation()}
        style={{
          background: t.surface, borderRadius: 16, padding: "36px 32px",
          maxWidth: 420, width: "90%", textAlign: "center",
          boxShadow: "0 20px 60px rgba(0,0,0,0.2)",
          border: `1px solid ${t.border}`,
        }}
      >
        <div style={{
          width: 56, height: 56, borderRadius: "50%", margin: "0 auto 20px",
          background: iconBg,
          display: "flex", alignItems: "center", justifyContent: "center",
          fontSize: 28,
        }}>
          {icon}
        </div>

        <div style={{
          fontSize: 20, fontWeight: 700, color: t.textPrimary,
          fontFamily: font.display, marginBottom: 10,
        }}>{title}</div>

        <div style={{
          fontSize: 13, color: t.textSecondary, lineHeight: 1.6,
          fontFamily: font.body, marginBottom: 28,
        }}>{message}</div>

        <div style={{ display: "flex", gap: 12 }}>
          <Button variant="outline" fullWidth onClick={onDismiss}>
            Maybe Later
          </Button>
          <Button variant="primary" fullWidth onClick={() => { onDismiss(); navigate("/settings"); }}>
            {isPlanLimit ? "Upgrade Plan" : "View Plans"}
          </Button>
        </div>
      </div>
    </div>
  );
}
